module.exports = __webpack_public_path__ + "static/media/ecommerce.64693109.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductEcommerce/assets/ecommerce.png
// module id = 502
// module chunks = 0